import * as Sentry from "@sentry/react";
import { apiUrl } from "./runtime.js";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
    // Route envelopes via our backend. Discord Activity's iframe CSP blocks
    // direct connections to *.ingest.sentry.io, so a direct Sentry.init
    // silently swallows every report. The tunnel handler at
    // shared/routes/sentryTunnel.ts forwards to the real ingest URL
    // (browser mode prefixes the backend host).
    tunnel: apiUrl("/api/sentry-tunnel"),
  });
}

// Thin wrappers so apps can attach context to Sentry reports without importing
// @sentry/react directly (shared owns the Sentry dependency). Setting a tag on
// the global scope means it rides along on EVERY captured exception — including
// the ones an ErrorBoundary catches deep inside a third-party library, where
// the stack alone (e.g. "Value is null at Array.map") tells us nothing about
// which ticker the user was on. With the tag, the Sentry report names the
// ticker so we can pull that symbol's snapshot from Supabase and inspect it.
export function setSentryTag(key: string, value: string): void {
  Sentry.setTag(key, value);
}

export function addSentryBreadcrumb(message: string, data?: Record<string, unknown>): void {
  Sentry.addBreadcrumb({ message, level: "info", ...(data ? { data } : {}) });
}
